import { Capacitor } from '@capacitor/core';
import { Box, useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';

export const AppBottomNavbar = (props: PropsWithChildren) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: '100%',
        bottom: 0,
        left: 0,
        right: 0,
        position: 'fixed',
        backgroundColor: theme.palette.background.paper,
        pb: Capacitor.isNativePlatform()
          ? 'var(--safe-area-inset-bottom)'
          : undefined,
      }}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '100%',
          borderTop: `1px solid ${theme.palette.divider}`,
          p: 2,
        }}
      >
        {props.children}
      </Box>
    </Box>
  );
};
